// 正式
// 这里得到打包分支变量
const theme = require('./env.theme.base')
// 这里得到具体 分支名字 说明文 引导文等信息
const themeDetail = require('./common.theme.set')
const { themeApi, themeWs } = require('./requestOperate')
module.exports = {
  title: themeDetail['themeTitle'][theme],
  baseApi: themeApi, // 正式api请求地址
  baseWs: themeWs,//正式api请求ws
  keywords: themeDetail['themekeywords'][theme], //正式说明文
  description: themeDetail['themeDescription'][theme], //正式引导文
  enname: themeDetail['themeEnName'][theme],//正式英文名
  bbh: themeDetail['themeBbh'][theme],//版本号
  name: themeDetail['themeName'][theme],//正式名字
  codenum: themeDetail['codenum'][theme],//代码统计
  httpwz: themeDetail['themeWz'][theme],
  // $cdn: 'https://www.xxxx.cn/static',//cdn名字
  projectType: theme,
  privateCdn: themeDetail['privateCdn'][theme],
  publickCdn: themeDetail['publickCdn'][theme],
  publickCdnjs: themeDetail['publickCdnjs'][theme],
  apiVersion: themeDetail['themeApiVersion'][theme],
}